import request from 'umi-request';
import type { ApiResponse } from '../model/apiResponse';
import { environment } from './../../environment/environment';
import type { AccidentSupportRequest } from '../model/accidentSupportRequest';
import type { DocumentRequest } from '../model/documentRequest';

export async function UpdateAccidentSupportService(id: string, accidentSupportRequest: AccidentSupportRequest, token: string): Promise<ApiResponse> {
  return request(`/accidentsupport/${id}`, {
    method: 'PUT',
    prefix: environment.baseUrl,
    body: JSON.stringify(accidentSupportRequest),
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (reponse: ApiResponse) {
      return reponse
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function getAccidentSupportService(token: string, formId: string): Promise<ApiResponse> {
  return request('/AccidentSupport/list/pwa/', {
    method: 'GET',
    prefix: environment.baseUrl,
    suffix: formId,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (reponse: ApiResponse) {
      return reponse
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function DocumentService(documentRequest: DocumentRequest, token: string): Promise<ApiResponse> {
  return request('/document', {
    method: 'POST',
    prefix: environment.baseUrl,
    body: JSON.stringify(documentRequest),
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (reponse: ApiResponse) {
      return reponse
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function GetAccidentSupportDetails(token: string, accidentSupportId: string): Promise<ApiResponse> {
  return await request('/AccidentSupport/', {
    method: 'GET',
    prefix: environment.baseUrl,
    suffix: accidentSupportId,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}



export async function GetForms(token: string, formTypeId: string): Promise<ApiResponse> {
  return await request('/AccidentSupport/getForm/listWithQuestions/', {
    method: 'GET',
    prefix: environment.baseUrl,
    suffix: formTypeId,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function CreateAccidentSupportService(accidentSupportRequest: AccidentSupportRequest, formTypeId: string, token: string): Promise<ApiResponse> {
  return request(`/accidentsupport/addForm/${formTypeId}`, {
    method: 'POST',
    prefix: environment.baseUrl,
    body: JSON.stringify(accidentSupportRequest),
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (reponse: ApiResponse) {
      return reponse
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}


export async function GetGenericListDetails(token: string, accidentId: string, formId: string): Promise<ApiResponse> {
  return await request('/accidentsupport/formList/', {
    method: 'GET',
    prefix: environment.baseUrl,
    suffix: accidentId + '/' + formId,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}


export async function ViewDetail(token: string, accidentId: string, formId: string, listId: string): Promise<ApiResponse> {
  return await request('/accidentsupport/viewForm/', {
    method: 'GET',
    prefix: environment.baseUrl,
    suffix: accidentId + '/' + formId + '/' + listId,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}


export async function DeleteForm(token: string, accidentId: string, formId: string, listId: string): Promise<ApiResponse> {
  return await request('/accidentsupport/deleteForm/', {
    method: 'GET',
    prefix: environment.baseUrl,
    suffix: accidentId + '/' + formId + '/' + listId,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function ViewAccidentDetail(token: string, id: string): Promise<ApiResponse> {
  return await request('/accidentsupport/registration/', {
    method: 'GET',
    prefix: environment.baseUrl,
    suffix: id,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}